<script setup lang="ts">
</script>

<template>
  <div class="projectCard-skeleton preferredColumnCountGrid">
    <div v-for="i in 2" :key="i" class="projectCard-skeletonCard">
      <div class="skeleton-content">
        <div class="skeleton-image"></div>
        <div class="skeleton-text-lines">
          <div class="skeleton-line skeleton-line--title"></div>
          <div class="skeleton-line skeleton-line--subtitle"></div>
          <div class="skeleton-line skeleton-line--description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.projectCard {
  &-skeleton {
    --column-count: 2;
    --column-gap: var(--spc24-16);
  }

  &-skeletonCard {
    background: var(--gray-50);
    border-radius: 8px;
    border: 1px solid var(--gray-200);
    overflow: hidden;
    
    .skeleton-content {
      padding: 0;
      
      .skeleton-image {
        height: 200px;
        background: linear-gradient(90deg, var(--gray-200) 25%, var(--gray-100) 50%, var(--gray-200) 75%);
        background-size: 200% 100%;
        animation: skeleton-loading 1.5s infinite;
      }
      
      .skeleton-text-lines {
        padding: 1rem;
        
        .skeleton-line {
          height: 12px;
          background: linear-gradient(90deg, var(--gray-200) 25%, var(--gray-100) 50%, var(--gray-200) 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 8px;
          
          &--title {
            height: 16px;
            width: 75%;
          }
          
          &--subtitle {
            width: 50%;
          }
          
          &--description {
            width: 90%;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>